import Connection from 'utils/connection';
import { GET_CURRENT_LANG_DICTIONARY_ITEM } from 'constants/api';

const getCurrentLangDictionary = keyName => Connection.post(GET_CURRENT_LANG_DICTIONARY_ITEM, keyName);

export default { getCurrentLangDictionary };
